import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { useDispatch, useSelector } from 'react-redux';
import { getOrganisationalStructure } from "../../../store/organisationalSlice";
import { Link } from "react-router-dom";

const Third = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { organisationalStructure, loading, error } = useSelector((state) => state.organisationalStructure);

    useEffect(() => {
        dispatch(getOrganisationalStructure());
    }, [dispatch]);

    if (loading) return <p>{t('instructors_slider.loading')}</p>;
    if (error) return <p>{t('instructors_slider.error', { error })}</p>;

    return (
        <section className="bg-white py-16 px-[20px] sm:px-12 md:px-16 lg:px-[50px] text-center">
            <h2 className="text-[24px] sm:text-[44px] font-semibold text-[#0A1F44]">{t('instructors_slider.our_instructors')}</h2>

            <div className="mt-10 relative">
                <Swiper
                    spaceBetween={20}
                    navigation={{
                        nextEl: ".swiper-next",
                        prevEl: ".swiper-prev",
                    }}
                    modules={[Navigation]}
                    className="swiper-container"
                    breakpoints={{
                        320: { slidesPerView: 2 },
                        768: { slidesPerView: 4 },
                        1024: { slidesPerView: 5 },
                        1280: { slidesPerView: 5 },
                    }}
                >
                    {organisationalStructure?.filter(item => item.status === "INSTRUCTOR")?.map((item, index) => (
                        <SwiperSlide
                            key={index}
                            className="flex flex-col justify-center items-center h-64 rounded-lg p-4"
                        >
                            <Link to={item.description} target={"_blank"}>
                                <img src={item.photo} alt={t('person.alt_text', { name: item.full_name, position: item.position })}
                                     className="w-[124px] h-[124px] sm:w-[164px] sm:h-[164px] rounded-full object-cover m-auto mb-3"/>
                                <p className="text-[18px] sm:text-[22px] font-semibold">{item.full_name}</p>
                                <p className="text-[13px] text-gray-500 block sm:hidden">{item.location}</p>
                            </Link>
                        </SwiperSlide>
                    ))}
                </Swiper>

                <div className="mt-8 flex justify-center items-center gap-6">
                    <button
                        className="swiper-prev swiper-button-disabled text-3xl text-[#0A1F44] hover:text-black transition">←
                    </button>
                    <span className="w-px h-6 bg-gray-500"></span>
                    <button className="swiper-next text-3xl text-[#0A1F44] hover:text-black transition">→</button>
                </div>
            </div>
        </section>
    );
};

export default Third;